import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription, 
    StatusComponentCreator,
    BooleanExcelDisplayCreator,
    DataMapper, 
} from '../../../components/BPMTable/TableMapperCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import { DirectTableQueryBuilder } from '../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder'


const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allDevices')}

class DeviceMinimalTableCreatorCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "DeviceMinimalTableCreatorCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, queries)
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'brand',
                new DataMapper("model.brand.name"),
                new f.FilterDescription(new f.TextFilter("brand")),
                {label: 'Brand'}
            ),
            new TableFieldDescription(
                'model',
                new DataMapper("model.name"),
                new f.FilterDescription(new f.TextFilter("model")),
                {label: 'Model'}
            ),
            new TableFieldDescription(
                'serviceType',
                new DataMapper("model.serviceType.name"),
                new f.FilterDescription(new f.TextFilter("serviceType")),
                {label: 'Service Type'}
            ),
            new TableFieldDescription(
                'serialNumber',
                new DataMapper("serialNumber", "id"),
                new f.FilterDescription(new f.TextFilter("serialNumber")),
                {label: 'Serial Number'}
            ),
            new TableFieldDescription(
                'serialNumberType',
                new DataMapper("serialNumberType.name"),
                new f.FilterDescription(new f.TextFilter("serialNumberType")),
                {label: 'Serial Number Type'}
            ),
            new TableFieldDescription(
                'isActive',
                new DataMapper("isActive"),
                new f.FilterDescription(new f.BooleanFilter("isActive")),
                {label: 'Status', componentCreator: new StatusComponentCreator(), excelDisplay: new BooleanExcelDisplayCreator()}
            ),
            new TableFieldDescription(
                'description',
                new DataMapper("description"),
                new f.FilterDescription(new f.TextFilter("description")),
                {label: 'Description', onlyForm: true}
            )
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(DeviceMinimalTableCreatorCreator)

export default DeviceMinimalTableCreatorCreator;
